//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fileFileApi } from '@/api/systemSetting';
import { getToken } from '@/utils/auth';
import { checkPermi } from '@/utils/permission';
export default {
  name: 'UploadFile',
  props: {
    value: {},
    // 业务弹窗里必须能传文件时（如门店开票上传发票）不受「文件上传」菜单权限限制；接口本身只校验登录
    skipPermi: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canUpload: function canUpload() {
      return checkPermi(['distribution:upload:file']);
    }
  },
  data: function data() {
    return {
      myHeaders: {
        'X-Token': getToken()
      },
      url: ''
    };
  },
  watch: {
    // 弹窗复用时外部清空/换值，内部显示要跟着变，否则会残留上一次的「已上传」
    value: function value(v) {
      this.url = v || '';
    }
  },
  beforeMount: function beforeMount() {
    if (this.value) {
      this.url = this.value;
    }
  },
  methods: {
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this = this;
      var formData = new FormData();
      var data = {
        model: this.$route.path.split('/')[1],
        pid: 10
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      fileFileApi(formData, data).then(function (res) {
        loading.close();
        _this.url = res.url;
        _this.$emit('input', _this.url);
        _this.$message.success('上传成功');
      }).catch(function (res) {
        loading.close();
      });
    }
  }
};